// Emulated object enum with a class because angular only supports numeric or string based enums
export class LinkTarget {

    static readonly PARAM_TAB_TARGET = new LinkTarget('paramTabTarget', 'cs.bia.permalink.target.analysis.parameters',
        '/bianalysis/load/');
    static readonly DIRECT_RESULT_TARGET = new LinkTarget('directResultTarget', 'cs.bia.permalink.target.analysis.table',
        '/bianalysis/load/');
    static readonly READ_ONLY_TARGET = new LinkTarget('readOnlyTarget', 'cs.bia.permalink.target.analysis.shared', '/bianalysis/share-bi-analysis/');

    private constructor(
        public readonly id: string,
        public readonly label: string,
        public readonly route: string,
    ) {
    }
}
